var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointIcon = function SvgPointIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F6A623"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.001 15H8.629V12.107H9.718C11.467 12.107 12.864 11.271 12.864 9.412C12.864 7.487 11.478 6.86 9.674 6.86H7.001V15ZM8.629 10.82V8.147H9.553C10.675 8.147 11.269 8.466 11.269 9.412C11.269 10.347 10.73 10.82 9.608 10.82H8.629Z",
    fill: "white"
  })));
};
export default SvgPointIcon;